export const filter = {
  filter: {
    shape:
      '<path fill="#000" fill-opacity=".98" fill-rule="evenodd" d="M18.063 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm.937.5a2 2 0 0 1-3.874 0H4v-1h11.126A2 2 0 0 1 19 7.5h1v1h-1Zm-15 7v1h11.126a2 2 0 0 0 3.874 0h1v-1h-1a2 2 0 0 0-3.874 0H4ZM6.937 10a2 2 0 0 1 1.937 1.5H20v1H8.874A2 2 0 0 1 5 12.5H4v-1h1A2 2 0 0 1 6.937 10Zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm11.126 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" clip-rule="evenodd"/>',
    viewBox: [0, 0, 24, 24],
  },
};
